import { Injectable } from "@angular/core";
import { PrelevementGenerateurDialyse } from "src/app/domain/Dialyse/prelevement-generateur-dialyse";
import { mapper } from "src/app/tools/mapping/mapper";
import { db } from "../db";
import { PrelevementRepository } from "./prelevement.repository";
import { PrelevementGenerateurDialyseEntity } from "../prelevement-generateur.entity";
import { GenerateurEntity } from "../generateur.entity";

@Injectable({
    providedIn: 'root',
})
export class PrelevementGenerateurRepository {

    constructor(private prelevementRepository: PrelevementRepository,

    ) { }

    async getPrelevementGenerateurEntityById(id: number) {
        return await db.prelevementGenerateurs.where('Id').equals(id).first(async ze => {
            return ze;
        });
    }

    async getPrelevementGenerateurDialyseById(id: number) {
        return await db.prelevementGenerateurs.where('Id').equals(id).first(async ze => {
            const z = mapper.map(ze, PrelevementGenerateurDialyseEntity, PrelevementGenerateurDialyse);

            if (ze?.PrelevementId) {
                z.Prelevement = await this.prelevementRepository.getPrelevementById(ze?.PrelevementId)
            }
            return z;
        });
    }

    async attachPrelevementGenerateurDialyse(app: PrelevementGenerateurDialyse, generateurEntity: GenerateurEntity) {
        let gId: number;
        const ge = mapper.map(app, PrelevementGenerateurDialyse, PrelevementGenerateurDialyseEntity);

        // const ae = await this.generateurRepository.getGenerateurEntityById(appId);
        ge.Id = await db.prelevementGenerateurs.add(ge);
        generateurEntity.PrelevementGenerateurDialyseIds = generateurEntity?.PrelevementGenerateurDialyseIds ? [...generateurEntity.PrelevementGenerateurDialyseIds, ge.Id] : [ge.Id]
        await db.generateurs.update(generateurEntity, {
            PrelevementGenerateurDialyseIds: generateurEntity?.PrelevementGenerateurDialyseIds
        });

        if (app.Prelevement) {
            await this.prelevementRepository.attachPrelevementToGenerateur(app.Prelevement, ge.Id);
        }

        return ge.Id;
    }
}